export function removeError(options) {
	return {
		type: 'REMOVE_ERROR',
		...options,
	};
}

export function connectionOnline() {
	return { type: 'CONNECTION_ONLINE' };
}

export function connectionOffline() {
	return { type: 'CONNECTION_OFFLINE' };
}
